<!--
 * @Date: 2024-06-14 10:27:03
 * @LastEditTime: 2024-09-24 14:12:33
 * @Description: Header
 * @FilePath: /ql-official/src/components/PcHeader.vue
-->

<template>
  <div class="pc-header">
    <div class="head-logo">
      <div class="head-left">
        <img :src="logoUrl" v-if="logoUrl" alt="云南省归国华侨联合会" />
        <div v-else class="logo-placeholder" />
        <div class="logo-text">
          <div>云南省归国华侨联合会</div>
          <div class="logo-sub">
            YUNNAN PROVINCE FEDERATION OF RETURNED OVERSEAS CHINESE
          </div>
        </div>
      </div>
      <div class="head-right">
        <div class="head-tip">
          <div class="tip-type">
            <span>微信</span>
            <img src="../assets/wechat.jpg" alt="WeChat" />
          </div>
          <!-- |
          <div class="tip-type">
            <span>手机版</span>
            <img src="../assets/banner_1.jpeg" />
          </div> -->
        </div>
        <div class="search">
          <input
            class="search-input"
            type="text"
            placeholder="请输入关键词"
            v-model="keyword"
            @keyup.enter="goSearch"
          />
          <div class="search-btn" @click="goSearch">
            <img src="../assets/icon_search.png" />
          </div>
        </div>
      </div>
    </div>
    <div class="nav">
      <ul class="main-menu">
        <template v-for="item in category">
          <li :key="item.id">
            <a
              v-if="item.categoryName === '云南省情'"
              href="https://www.yn.gov.cn/yngk"
              target="_blank"
            >
              {{ item.categoryName }}
            </a>
            <router-link
              v-else
              :to="createLocationOption(item, item.categoryName)"
            >
              {{ item.categoryName }}
            </router-link>
            <ul
              class="sub-menu"
              v-if="item.children && item.children.length > 0"
            >
              <li v-for="child in item.children" :key="child.id">
                <router-link
                  :to="createLocationOption(child, item.categoryName)"
                >
                  {{ child.categoryName }}
                </router-link>
              </li>
            </ul>
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

import http from "@/utils/http";
import { CategoryTreesDto } from "@/type/type";
import { handlingUrl } from "@/utils";

@Component({})
export default class PcHeader extends Vue {
  logoUrl?: string | null = null;
  category: CategoryTreesDto[] = [];
  keyword = "";

  async getLogoUrl() {
    try {
      const result: string = await http.get("/api/Logo/Get");
      if (result) {
        this.logoUrl = handlingUrl(result);
      }
    } catch (error) {
      console.error("error :>> ", error);
    }
  }

  async getCategory() {
    try {
      const result = await http.get("/api/Category/GetTrees");
      if (Array.isArray(result)) {
        this.category = result;
      }
    } catch (error) {
      console.error("error :>> ", error);
    }
  }

  createLocationOption(item: CategoryTreesDto, name?: string | null) {
    if (item.categoryName === "首页") {
      return { path: "/" };
    }

    return {
      path: "/pc/list",
      query: {
        id: item.id,
        parentId: item.parentId,
        name: name,
      },
    };
  }

  goSearch() {
    if (!this.keyword) {
      return;
    }

    this.$router.push({
      path: "/pc/search",
      query: {
        keyword: this.keyword,
        t: new Date().getTime().toString(),
      },
    });
  }

  mounted() {
    this.getLogoUrl();
    this.getCategory();
  }
}
</script>

<style lang="less">
.pc-header {
  .head-logo {
    display: flex;
    width: 1200px;
    margin: 0 auto;
    justify-content: space-between;
    padding-top: 30px;
    align-items: center;

    .head-left {
      display: flex;
      align-items: center;

      img {
        height: 105px;
        margin-right: 10px;
      }

      .logo-placeholder {
        height: 105px;
        margin-right: 10px;
      }

      .logo-text {
        font-family: Arial, Helvetica, sans-serif;
        font-size: 36px;
        font-weight: 500;
        line-height: normal;
        letter-spacing: 0em;
        color: #008bec;

        .logo-sub {
          font-size: 11px;
          color: #008bec;
        }
      }
    }
  }

  .head-right {
    .search {
      display: flex;
      height: 42px;

      .search-input {
        height: 38px;
        font-family: Arial, Helvetica, sans-serif;
        font-size: 18px;
        display: block;
        text-indent: 14px;
        width: 300px;
        background: #f9f9f9;
        border: 1px solid #e6e6e6;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
      }

      .search-btn {
        width: 50px;
        height: 100%;
        cursor: pointer;
        background: #e4141d;
        border: none;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 28px;
          height: 28px;
        }
      }
    }

    .head-tip {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 6px;
      // margin-right: 50px;
      color: #999999;

      .tip-type {
        position: relative;

        span {
          cursor: pointer;
          margin: 0 6px;
        }

        img {
          display: none;
          position: absolute;
          left: -30px;
          width: 120px;
          height: 120px;
          bottom: -120px;
          z-index: 9;
        }
      }

      .tip-type:hover img {
        display: block;
      }
    }
  }

  .nav {
    background: #e4141d;
    box-sizing: border-box;
    line-height: 50px;
    height: 50px;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 24px;
    font-weight: 500;
    margin-top: 40px;
  }

  .main-menu {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    position: relative;
    background-color: #e4141d;

    li {
      width: 200px;
      text-align: center;
      position: relative;
      cursor: pointer;

      a {
        color: #ffffff;
        display: block;
      }
    }

    li:hover {
      background-color: #c0050d;
    }
  }

  .sub-menu {
    position: absolute;
    background-color: #e4141d;
    min-width: 160px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    z-index: 999;
    overflow: hidden;
    max-height: 0;
    transition: max-height 0.3s ease-out;

    li {
      background-color: #e4141d;

      a {
        color: #ffffff;
        padding: 8px 10px;
        display: block;
      }
    }

    li :hover {
      background-color: #c0050d;
    }
  }

  .main-menu li:hover .sub-menu {
    max-height: 1000px;
    /* 设置一个足够大的值，确保能展开所有内容 */
    transition: max-height 0.3s ease-in;
    /* 可以调整时长和缓动函数 */
  }
}
</style>
